function initSections() {
  if ($('.sections-module').length == 0) {
    return false;
  }

  function checkTabs() {
    const hash = location.href.split('#')[1];
    $('.sections-module-item').removeClass('show');
    $('.sections-module-tab').removeClass('section-active');
    $('.sections-module #' + hash).addClass('section-active');
    $('.sections-module-item[data-target="#' + hash + '"]').addClass('show');
  }

  $(document).ready(function () {
    $(window).on('hashchange', function () {
      checkTabs();
    });

    if (window.location.href.indexOf('#') > -1) {
      checkTabs();
    } else {
      $('.sections-module-tab[data-index=0]').addClass('section-active');
    }
  });

  $('.sections-module-tab').on('click', function () {
    const tabId = $(this).attr('id');
    const hash = '#' + tabId;
    const newUrl = location.href.split('#')[0] + hash;
    $('.sections-module-tab').not(this).removeClass('section-active');
    $(this).addClass('section-active');
    $('.sections-module-item').removeClass('show');
    $('.sections-module-item[data-target="#' + tabId + '"]').addClass('show');
    history.pushState(null, null, newUrl);
  });

  if ($('.sections-module-tab').length < 2) {
    $('.sections-module-header').addClass('hidden');
  }
}

export { initSections }



// WEBPACK FOOTER //
// ./scripts/modules/sections.js